import React from 'react';
import HeroSection from './HeroSection';
import RunningSection from './SponsorSection';
import AboutSection from './AboutSection';
import ServicePremiumSection from './ServicePremiumSection';

import ColorPallete from '../../../../utils/ColorPallet'

function MainSection() {
  return (
   <div className='min-h-screen' style={{ backgroundColor: ColorPallete.primaryLightBrown }}>
      <HeroSection />
      <RunningSection />
      <AboutSection />
      <div className='bg-gradient-to-r from-blue-600 to-purple-600'>
        <ServicePremiumSection />
      </div>
    </div>
  )
}

export default MainSection